import * as yup from 'yup';
import { FORM_MESSAGE } from '../../fastForm/data/constants';
import { PAYMENT_SCHEMA__READY_TO_POST_ERROR } from '../data/constants';

export const paymentSchema = (readyToPost: boolean) =>
	yup.object().shape({
		payment: yup.object().shape({
			amount: yup
				.string()
				.required(FORM_MESSAGE.required)
				.test('number', FORM_MESSAGE.number, (value) => {
					if (value === undefined || value === null) {
						return true;
					}
					return !isNaN(Number(value));
				}),
			amountCurrency: yup.string().required(FORM_MESSAGE.required),
			policyLocator: readyToPost
				? yup.string().required(PAYMENT_SCHEMA__READY_TO_POST_ERROR)
				: yup.string(),
		}),
	});
